const page = 'DocumentsPage';

export default page;
